import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SelectionToggle from './SelectionToggle';
import palette from '../../styles/palette';

const HelpCard = ({ rate, onToggle }) => {
  const styles = {
    container: {
      border: `1px solid ${palette.gt_grey_light_5}`,
      borderRadius: '4px',
      marginBottom: '0px',
    },
    header: {
      backgroundColor: `${palette.gt_teal_1}`,
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1em',
    },
    titleText: {
      typography: { xs: 'body1', md: 'body1', lg: 'h6' },
    },
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Typography sx={styles.titleText}>
          <strong>{`Need some design help?`}</strong>
        </Typography>
        <Typography color="text.secondary">
          <strong>&#x24;{rate}</strong>
        </Typography>
      </Box>
      <SelectionToggle
        label={`Get your postcard designed by our experts`}
        onToggle={onToggle}
      />
    </Box>
  );
};

export default HelpCard;
